import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Moon } from "lucide-react";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import CosmicBackground from "../components/astro/CosmicBackground";
import PanchangCard from "../components/astro/PanchangCard";
import { Reveal } from "../components/Reveal";
import { useLang } from "../i18n/LanguageContext";

export default function PanchangPage() {
  const { t } = useLang();
  return (
    <div className="relative" data-testid="panchang-page">
      <Seo
        title="Daily Panchang — Tithi, Nakshatra, Rahu Kaal"
        description="Today's Panchang for Tarapith: Tithi, Nakshatra, Yoga, Karana, sunrise, sunset, Rahu Kaal, Gulika Kaal, Abhijit and Brahma Muhurta, computed live with the Swiss Ephemeris."
        path="/astrology/panchang"
        keywords={["daily panchang", "rahu kaal today", "abhijit muhurta", "tithi today", "nakshatra today"]}
      />
      <CosmicBackground />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <Breadcrumbs items={[{ label: "Astrology", to: "/astrology" }, { label: "Daily Panchang" }]} />
        <Reveal variant="blur" className="max-w-2xl mb-9">
          <span className="badge-gold mb-5 inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-[11px] font-serif uppercase tracking-[0.28em]">
            <Moon className="h-3.5 w-3.5" /> Daily Panchang
          </span>
          <h1 className="font-serif text-4xl sm:text-5xl font-bold leading-tight mb-4">
            <span className="text-gradient-flame">Today's sacred timings</span>
          </h1>
          <p className="text-base text-tara-body leading-relaxed">
            The Panchang below is calculated live for Tarapith in Indian Standard Time — use Abhijit and Brahma
            Muhurta for auspicious beginnings and sadhana, and set aside Rahu Kaal for routine matters.
          </p>
        </Reveal>

        <PanchangCard />

        <div className="mt-8 flex flex-wrap gap-4">
          <Link to="/astrology/kundali" className="btn-sacred flex items-center gap-2 rounded-full px-6 py-3.5 text-sm font-serif font-semibold" data-testid="panchang-kundali-link">
            Generate my Kundali <ArrowRight className="h-4 w-4" />
          </Link>
          <Link to="/festivals" className="btn-ghost-gold flex items-center gap-2 rounded-full px-6 py-3.5 text-sm font-serif font-semibold" data-testid="panchang-festivals-link">
            {t("nav_festivals")} <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
